import type { CSSProperties } from 'react';
import { COLORS, mono } from '../takeoff/primitives.tsx';

export { COLORS, mono };

export const cellInput: CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  background: 'rgba(255,255,255,0.04)',
  border: `1px solid ${COLORS.borderStrong}`,
  borderRadius: 4,
  color: COLORS.text,
  fontSize: 12,
  padding: '4px 6px',
  fontFamily: "'Outfit', sans-serif",
  outline: 'none',
};

export const cellSelect: CSSProperties = {
  ...cellInput,
  fontFamily: "'JetBrains Mono', monospace",
};

export const formInput: CSSProperties = {
  ...cellInput,
  fontSize: 13,
  padding: '6px 8px',
};

export const formSelect: CSSProperties = {
  ...cellSelect,
  fontSize: 13,
  padding: '6px 8px',
};

export const segmentNameInput: CSSProperties = {
  flex: 1,
  background: 'transparent',
  border: 'none',
  borderBottom: '1px dashed rgba(255,255,255,0.2)',
  color: COLORS.text,
  fontFamily: "'Syne', sans-serif",
  fontWeight: 700,
  fontSize: 14,
  outline: 'none',
  padding: '2px 4px',
  minWidth: 0,
};

export const chevronBtn: CSSProperties = {
  background: 'transparent',
  border: 'none',
  color: COLORS.textDim,
  fontSize: 14,
  cursor: 'pointer',
  padding: '2px 4px',
  width: 20,
  flexShrink: 0,
};

export const dangerBtn: CSSProperties = {
  background: 'transparent',
  border: `1px solid ${COLORS.redBorder}`,
  color: COLORS.red,
  borderRadius: 4,
  padding: '2px 8px',
  fontSize: 13,
  cursor: 'pointer',
};

export const dangerBtnSmall: CSSProperties = {
  ...dangerBtn,
  padding: '1px 5px',
  fontSize: 11,
};

export const primaryBtn: CSSProperties = {
  background: COLORS.greenSoft,
  border: `1px solid ${COLORS.greenBorder}`,
  color: COLORS.green,
  borderRadius: 6,
  padding: '8px 14px',
  fontSize: 13,
  cursor: 'pointer',
  fontFamily: "'Outfit', sans-serif",
  alignSelf: 'flex-start',
};

export const ghostBtn: CSSProperties = {
  background: 'transparent',
  border: `1px solid ${COLORS.borderStrong}`,
  color: COLORS.textMuted,
  borderRadius: 6,
  padding: '6px 10px',
  fontSize: 12,
  cursor: 'pointer',
  fontFamily: "'Outfit', sans-serif",
};

export const addLineBtn: CSSProperties = {
  ...primaryBtn,
  fontSize: 12,
  padding: '6px 10px',
  marginTop: 4,
};

export const iconBtn: CSSProperties = {
  background: 'transparent',
  border: 'none',
  color: COLORS.textDim,
  borderRadius: 4,
  padding: '2px 6px',
  fontSize: 13,
  cursor: 'pointer',
  lineHeight: 1,
};

export const iconBtnDanger: CSSProperties = {
  ...iconBtn,
  color: COLORS.red,
};

export const tagBtn = (active: boolean, color: 'amber' | 'red' | 'dim'): CSSProperties => {
  const map = {
    amber: { bg: COLORS.amberSoft, border: COLORS.amberBorder, fg: COLORS.amber },
    red: { bg: 'rgba(255,107,122,0.08)', border: COLORS.redBorder, fg: COLORS.red },
    dim: { bg: 'transparent', border: COLORS.border, fg: COLORS.textDim },
  } as const;
  const c = map[active ? color : 'dim'];
  return {
    background: c.bg,
    border: `1px solid ${c.border}`,
    color: c.fg,
    borderRadius: 999,
    padding: '1px 8px',
    fontSize: 10,
    cursor: 'pointer',
    fontFamily: "'JetBrains Mono', monospace",
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
  };
};
